import { ButtonColors } from 'types';
import { Icon } from 'components/icon';
import { Button } from 'components/button';

import { BackCategoryButtonProps } from './types';

export const BackCategoryButton = ({
  text,
  onClose,
}: BackCategoryButtonProps) => (
  <Button
    transparent
    padding="0"
    onClick={onClose}
    icon={<Icon.ChevronLeft />}
    colorType={ButtonColors.LightBlue}
    text={text || 'Back to Categories'}
  />
);

export type { BackCategoryButtonProps };
